import React from "react"
import { AppProvider } from "./src/context/AppContext"
import "@fontsource/fraunces/600.css"
import "@fontsource/quicksand/500.css"
import "@fontsource/quicksand/600.css"
import "@fontsource/quicksand/700.css"
import "@fontsource/caveat/600.css"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <AppProvider>{element}</AppProvider>
}
